import React, { FC } from 'react';
import { PlannedTwinID } from '../../../../../config/types';
import { getContextStores } from '../../../../../context';
import PlannedTwinIDPropertiesSubTable from './PlannedTwinIDPropertiesSubTable';
import UpdateToolExpandableTable from '../../../../../components/atoms/UpdateToolExpandableTable';

interface Props {
  updatesKey: 'created' | 'deleted' | 'byTwinID'
}

const PlannedTwinIDPropertiesTable: FC<Props> = ({ updatesKey }) => {
  const contextStores = getContextStores();
  const { plannedTwinIDUpdateState, assetState } = contextStores;

  const { isFetchingAssets } = assetState || {};
  const { isPlanningPlannedTwinIDs } = plannedTwinIDUpdateState || {};
  const isLoading = isFetchingAssets || isPlanningPlannedTwinIDs;
  const { plannedUpdatedPlannedTwinID } = plannedTwinIDUpdateState || {};

  const plannedTwinIDs = plannedUpdatedPlannedTwinID?.updates[updatesKey]
    || [] as PlannedTwinID[];

  const expandedRowRender = (
    record: PlannedTwinID,
  ) => <PlannedTwinIDPropertiesSubTable record={record} />;

  return (
    <UpdateToolExpandableTable
      isLoading={isLoading}
      dataIndex="twinID"
      data={plannedTwinIDs}
      expandedRowRender={expandedRowRender}
    />
  );
};

export default PlannedTwinIDPropertiesTable;
